<template>
  <div v-editable="blok" class="w-full">
    <NuxtPicture
      v-if="blok && imageSource && imageSource.src"
      v-observe-visibility="visibilityObserver"
      class="picture"
      :class="{
        'picture-cover sm:block': $device.isDesktop || aspectRatio,
        'picture-contain': $device.isMobile && !aspectRatio,
        'picture-height picture-width block': aspectRatio,
      }"
      :height="height"
      provider="storyblok"
      :src="imageSource.src"
      :alt="imageSource.alt"
      :sizes="defaultSizes"
      :style="{ aspectRatio: aspectRatio }"
    />
  </div>
</template>

<script setup lang="ts">
import { getTeaserImage, getCmsImage } from '../utils/cmsImages'
import type { SbImage } from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  height: {
    type: Number as PropType<number>,
    default: undefined,
  },
  isTeaser: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  aspectRatio: {
    type: String as PropType<string>,
    default: '',
  },
  blok: {
    type: Object as PropType<SbImage>,
    default: () => {},
  },
})

const imageSource = computed(() =>
  props.isTeaser ? getTeaserImage(props.blok) : getCmsImage(props.blok),
)
const visibilityObserver = props.blok.promotion_id
  ? {
      once: true,
      intersection: {
        threshold: 0.5,
      },
      callback: () => {},
    }
  : null
</script>
../utils/cmsImages
